var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-footer',{staticClass:"justify-content-center"},[_c('p',{staticClass:"text-center"},[_vm._v(" © 2021 Warzywa Damian i Dominika Trójmiasto "),_c('br'),_vm._v(" Rokitnica, 83-021 Pruszcz Gdański ")])])}
var staticRenderFns = []

export { render, staticRenderFns }